(() => {
  if (window.__giftMeJapanBundleGroupLimit) return;
  window.__giftMeJapanBundleGroupLimit = true;

  const getContext = (element) => {
    const wrapper = element.closest('.product-bundle-wrapper');
    if (!wrapper) return null;
    const bundle = wrapper.querySelector('product-bundle[data-prevent-duplicate-groups]');
    return bundle ? { wrapper, bundle } : null;
  };

  const groupCards = (wrapper, group) =>
    Array.from(wrapper.querySelectorAll('.product-card[data-bundle-group]'))
      .filter((card) => card.dataset.bundleGroup === group);

  const lockGroup = (wrapper, group) => {
    groupCards(wrapper, group).forEach((card) => {
      card.setAttribute('locked', '');
      card.setAttribute('data-bundle-group-locked', '');

      const button = card.querySelector('form[is="product-bundle-form"] button[name="add"]');
      if (button && !button.disabled) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-bundle-group-disabled', '');
      }
    });
  };

  const unlockGroup = (wrapper, group) => {
    groupCards(wrapper, group).forEach((card) => {
      card.removeAttribute('data-bundle-group-selected');

      if (card.hasAttribute('data-bundle-group-locked')) {
        card.removeAttribute('locked');
        card.removeAttribute('data-bundle-group-locked');
      }

      const button = card.querySelector('form[is="product-bundle-form"] button[name="add"]');
      if (button?.hasAttribute('data-bundle-group-disabled')) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.removeAttribute('data-bundle-group-disabled');
      }
    });
  };

  const rowTitle = (row) =>
    row.querySelector('.horizontal-product__title')?.textContent.trim() || '';

  const findCardByTitle = (wrapper, title) =>
    Array.from(wrapper.querySelectorAll('.product-card[data-bundle-group]'))
      .find((card) => card.querySelector('form[is="product-bundle-form"]')?.dataset.productTitle === title);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('form[is="product-bundle-form"]');
    if (!form) return;

    const card = form.closest('[data-bundle-group]');
    const context = card && getContext(card);
    const group = card?.dataset.bundleGroup;
    if (!context || !group) return;

    const alreadySelected = groupCards(context.wrapper, group)
      .some((groupCard) => groupCard.hasAttribute('data-bundle-group-selected'));

    if (alreadySelected) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    card.setAttribute('data-bundle-group-selected', '');

    window.setTimeout(() => {
      const selectedRow = Array.from(context.bundle.querySelectorAll('[data-product-bundle-variant]'))
        .find((row) => rowTitle(row) === form.dataset.productTitle);

      if (selectedRow) {
        selectedRow.dataset.bundleGroup = group;
        lockGroup(context.wrapper, group);
      } else {
        unlockGroup(context.wrapper, group);
      }
    }, 0);
  }, true);

  document.addEventListener('click', (event) => {
    const removeButton = event.target.closest?.('product-bundle-remove-button');
    if (!removeButton) return;

    const row = removeButton.closest('[data-product-bundle-variant]');
    const context = row && getContext(row);
    if (!row || !context) return;

    const matchingCard = findCardByTitle(context.wrapper, rowTitle(row));
    const group = row.dataset.bundleGroup || matchingCard?.dataset.bundleGroup;
    if (!group) return;

    window.setTimeout(() => {
      const groupStillSelected = Array.from(context.bundle.querySelectorAll('[data-product-bundle-variant]'))
        .some((bundleRow) => bundleRow !== row && bundleRow.dataset.bundleGroup === group && rowTitle(bundleRow));

      if (!groupStillSelected) unlockGroup(context.wrapper, group);
    }, 0);
  }, true);
})();
